import styles from "./styles.module.css";
import global from "../../app.module.css";
import PersonApp from "../../modules/person";
import CompanyApp from "../../modules/company";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Box } from "@mui/system";
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

function RegisterComponent(props) {
    const { company } = props
    const registerState = company ? 'empresa' : 'persona'
    const [tipo, setTipo] = useState(registerState);


    const selectTipo = (e, newValue) => {
        setTipo(newValue)
        console.log("selectTipo", e.target.value) 
    }

    return (
        <div className={`${styles.contenedor} ${global.background}`}>
            <div className={`${styles.panel}`}>
                <div className={`${styles.tipoRegistro}`}>
                <img src = "https://firebasestorage.googleapis.com/v0/b/chat-asesores-desa.appspot.com/o/Avanti-it%2Fimages%2FLogo.png?alt=media&token=975ba68f-1054-4859-8fb3-3b6954213c2f"
                            alt="Logo" width="250" 
                     height="130"/>
                <Box sx={{  width: '100%'  }}
                    variant="fullWidth"
                >
                    <Tabs 
                        value={tipo} 
                        style={{ display: 'initial' }}
                        onChange={selectTipo}
                        centered
                        >
                        <Tab value="persona"
                        sx={{  width: 200  }}
                        label="Soy persona" 
                        icon={< PersonAddIcon/>}
                        />
                        <Tab value="empresa" 
                        sx={{  width: 200  }}
                        label="Soy empresa" 
                         icon={<AddBusinessIcon/>}
                        />
                    </Tabs>
                </Box>
                </div>
                <div className={`${styles.formularios}`}>
                    {tipo === 'persona' ? <PersonApp /> : <CompanyApp />}
                </div>
            </div>
        </div>
    );
}

export default RegisterComponent;